// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('accountingBunt', {
//         templateUrl: 'views/components/views/accountingBunt/accountingBunt.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'base64', 'accountingBuntComponentService', 'ttGridFactory', function ($stateParams, stateService, utilityService, translateService, modalService, base64, accountingBuntComponentService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let webPageName = stateService.getCurrentName();
//             let accountingBuntKeyno = $stateParams.accountingbunt_keyno;
//             let itemsListInvoices = [];

//             let progressionInfo = {
//                 runProgress: 'START',
//                 label: 'progressbar',
//                 plabel: '',
//                 field: '',
//                 remField: '',
//                 min: 0,
//                 max: 100,
//                 step: 0,
//                 finishclose: '1',
//                 abortclose: false
//             };

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 webPageName: webPageName,
//                 gridReady: false,
//                 edit: {},
//                 lockedSave: false,
//                 creatingInvoice: false,
//                 updatingInvoice: false,
//                 creatingFile: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: '',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setToolbar({ wrapping: true });

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await accountingBuntComponentService.getEdit({ accountingbunt_keyno: accountingBuntKeyno }))[0];
//             }

//             async function loadAccountingBuntInvoices() {
//                 if (utilityService.validateParmsValue(vm.model.edit.accountingbunt_keyno) !== true) return;

//                 return itemsListInvoices = await accountingBuntComponentService.listInvoices({ accountingbunt_keyno: vm.model.edit.accountingbunt_keyno });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 if (utilityService.validateParmsValue(vm.model.edit.view_id) === true) {
//                     vm.grid.dataTask.rememberId = vm.model.edit.view_id;

//                     if (utilityService.validateParmsValue(vm.model.edit.p2_datatask_keyno) === true && utilityService.validateParmsValue(vm.model.edit.sent_ok) === true) {
//                         vm.grid.dataTask.loadData = {
//                             method: vm.model.edit.p2_datatask_keyno,
//                             parameters: vm.model.edit
//                         };

//                         vm.model.gridReady = true;

//                         if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                     }
//                 }
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region CREATE FILE BUTTON FUNCTION

//             vm.createFile = function () {
//                 if (utilityService.validateParmsValue(vm.model.edit.accountingbunt_keyno) !== true) return;

//                 vm.model.creatingFile = true;

//                 accountingBuntComponentService.exportAccountingBunt({ accountingbunt_keyno: vm.model.edit.accountingbunt_keyno }).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.creatingFile = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.creatingFile = false;
                        
//                         var elem = document.getElementById('formAccountingBuntLink');
//                         var text = base64.urldecode(response[0].filecontent);

//                         var txtData = new Blob([text], { type: 'text/txt' });
//                         var txtUrl = URL.createObjectURL(txtData);

//                         elem.setAttribute('href', txtUrl);
//                         elem.setAttribute('download', response[0].filename);
//                         elem.click();
//                     }
//                 });
//             }

//             // #endregion CREATE FILE BUTTON FUNCTION

//             // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

//             function activateProgress(items) {
//                 let increment = 1, skip = 0, failed = 0, step = 0;
//                 progressionInfo.step = 0;

//                 function doStep() {
//                     setTimeout(() => {
//                         modalService.progressInfo.finishclose = '0';

//                         if (progressionInfo.runProgress === 'ABORT') return;
//                         if (progressionInfo.step >= progressionInfo.max) return;

//                         step = progressionInfo.step + skip + failed;
//                         progressionInfo.field = 'ID: ' + items[step].item_id;
//                         modalService.progressInfo.field = progressionInfo.field;

//                         accountingBuntComponentService.makeInvoice({ item_id: items[step].item_id }).then((response) => {
//                             if (response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: (dialogItself) => {
//                                             dialogItself.close();

//                                             progressionInfo.runProgress = 'ABORT';
//                                             modalService.progressInfo.finishclose = '1';
//                                             modalService.progressInfo.abortclose = true;

//                                             doStep();
//                                         }
//                                     }]
//                                 });
//                             } else {
//                                 progressionInfo.step += increment;
//                                 modalService.progressInfo.step = progressionInfo.step;
//                                 modalService.progressInfo.finishclose = progressionInfo.finishclose;

//                                 doStep();
//                             }
//                         });
//                     });
//                 }

//                 doStep();
//             }

//             function progressFunc() {
//                 itemsListInvoices.forEach((item) => {
//                     if (item.item_id !== '0' || item.item_id !== '-1') progressionInfo.max++;
//                 });

//                 progressionInfo.max = itemsListInvoices.length;
//                 activateProgress(itemsListInvoices);

//                 modalService.showProgress(progressionInfo).then((value) => {
//                     progressionInfo.runProgress = value;

//                     if (progressionInfo.runProgress === 'ABORT') {
//                         vm.model.creatingInvoice = false;
//                         vm.model.updatingInvoice = false;
//                     }

//                     if (progressionInfo.runProgress === 'FINISH') {
//                         vm.model.creatingInvoice = false;
//                         vm.model.updatingInvoice = false;
//                         loadEdit();
//                         loadGrid();
//                     }
//                 });
//             }

//             // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 accountingBuntComponentService.saveObj(vm.model.edit).then((response) => {
//                     if (response[0] && response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: (dialogItself) => {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region CREATE INVOICE BUTTON FUNCTION

//             vm.createInvoice = function () {
//                 vm.model.creatingInvoice = true;
//                 progressFunc();
//             }

//             // #endregion CREATE INVOICE BUTTON FUNCTION

//             // #region UPDATE INVOICE BUTTON FUNCTION

//             vm.updateInvoice = function () {
//                 vm.model.updatingInvoice = true;
//                 progressFunc();
//             }

//             // #endregion UPDATE INVOICE BUTTON FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadGrid();
//                 loadAccountingBuntInvoices();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
